import ErrorUtils from '~/utils/error_utils';

export default {
    getStatuses(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-status',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan statuses.', xhr);
                reject(xhr);
            });
        });
    },

    getTypes(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-types',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan types.', xhr);
                reject(xhr);
            });
        });
    },

    getPrograms(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-programs',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan programs.', xhr);
                reject(xhr);
            });
        });
    },

    getPurposes(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-purposes',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan purposes.', xhr);
                reject(xhr);
            });
        });
    },

    getSubordinateFinancingTypes(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-subordinate-types',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan subordinate financing types.', xhr);
                reject(xhr);
            });
        });
    },

    getParticipantRoles(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-participants',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan participant roles.', xhr);
                reject(xhr);
            });
        });
    },

    getFormData(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/form-data-json',
                type: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan form data.', xhr);
                reject(xhr);
            });
        });
    },

    getLoanParticipants(id) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: `/loan/loan-participants/${id}`,
                method: 'GET',
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loan participants', xhr);
                reject(xhr);
            });
        });
    },

    getPushServices() {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/dt-push',
                method: 'GET',
                global: false,
            })
                .done((data) => {
                    resolve(data);
                })
                .fail((xhr) => {
                    reject(xhr);
                });
        });
    },

    getLoans(params) {
        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/loan/list-json',
                method: 'GET',
                data: params,
                global: false,
            })
            .done((data) => {
                resolve(data);
            })
            .fail((xhr) => {
                console.error('Failed to load loans', xhr);
                reject(ErrorUtils.createErrorFromXhr(xhr));
            });
        });
    },
};
